import { Box, Flex, IconArrowRight, Link, Text } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

type DashboardHeaderActionItemProps = {
  title: string;
  description: {
    leading?: string;
    highlighted?: string;
    trailing?: string;
  };
  to: string;
};

export default function DashboardHeaderActionItem(props: DashboardHeaderActionItemProps) {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Box pr={3}>
        <Text variant="text-body-medium" mb={1} color="tan">
          {props.title}
        </Text>
        <Text variant="text-body-meta-regular" color="tan">
          {props.description.leading}
          {props.description.highlighted && (
            <Link as={ReactRouterLink} to={props.to} variant="link-primary">
              <Text as="span" variant="text-body-meta-regular" color="alert-success-default">
                {props.description.highlighted}
              </Text>
            </Link>
          )}
          {props.description.trailing}
        </Text>
      </Box>
      <Link
        as={ReactRouterLink}
        to={props.to}
        variant="accent"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={10}
        height={10}
        p={0}
        borderRadius="radii-1"
        aria-label="Edit"
        leadingIcon={<IconArrowRight />}
      />
    </Flex>
  );
}
